/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, jsx } from '@atlaskit/css';
import { ExitingPersistence, SlideIn } from '@atlaskit/motion';
import { Box } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	wrapper: {
		overflow: 'hidden',
	},
});

type Props = {
	children: React.ReactNode;
	shouldTriggerAnimation: boolean;
};

export const SlideAnimationWrapper: React.FC<Props> = ({ children, shouldTriggerAnimation }) => (
	<ExitingPersistence>
		{shouldTriggerAnimation && (
			<Box xcss={styles.wrapper}>
				<SlideIn enterFrom="top" fade="inout">
					{(props) => <div {...props}>{children}</div>}
				</SlideIn>
			</Box>
		)}
	</ExitingPersistence>
);
